module.exports = __webpack_public_path__ + "img/kv_2_1.f45bb777.png";